import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import ActivityTable from '@activities/components/tables/activity-table/activity-table.vue';

@Component({
  name: 'bpc-activities',
  components: {
    'bpc-activity-table': ActivityTable,
  },
})
export default class Activities extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
